import { __assign, __rest } from "tslib";
import React from 'react';
import BiSpan from '../../../biLogger/Components/BiSpan';
import BiLink from '../../../biLogger/Components/BiLink';
import { ReferralType } from '../../../biLogger';
export var MobileSubmitMenuItem = function (_a) {
    var url = _a.url, isVerificationNeeded = _a.isVerificationNeeded, pushVerificationPopup = _a.pushVerificationPopup, verificationAction = _a.verificationAction, isLoggedIn = _a.isLoggedIn, restrictLoggedOut = _a.restrictLoggedOut, restProps = __rest(_a, ["url", "isVerificationNeeded", "pushVerificationPopup", "verificationAction", "isLoggedIn", "restrictLoggedOut"]);
    if (!isLoggedIn) {
        return (React.createElement(BiSpan, __assign({}, restProps, { onClick: function () {
                return restrictLoggedOut({ restrictedActionName: ReferralType.SUBMIT });
            } })));
    }
    if (verificationAction && isVerificationNeeded) {
        return (React.createElement(BiSpan, __assign({}, restProps, { onClick: function () { return pushVerificationPopup(verificationAction); } })));
    }
    if (url) {
        return React.createElement(BiLink, __assign({ href: url }, restProps));
    }
    return React.createElement(BiSpan, __assign({}, restProps));
};
MobileSubmitMenuItem.displayName = 'MobileSubmitMenuItem';
export default MobileSubmitMenuItem;
//# sourceMappingURL=MobileSubmitMenuItem.js.map